import moment from 'moment';
import { sum, toChartData } from '../../util/helper';

export function RESET_DETAIL(state) {
	state.campaign = {};
	state.campaignStatsData = {};
	state.impressionSum = 0;
	state.impressionChart = [];
	state.clickSum = 0;
	state.clickChart = [];
}

export function SET_CAMPAIGNS(state, campaigns) {
	state.campaigns = campaigns.filter(campaign => !campaign.defaultFor);
	state.defaultCampaign = campaigns.filter(campaign => campaign.defaultFor)[0] || {};
}

export function SET_CAMPAIGN(state, campaign) {
	let days = moment(campaign.time[1], 'DD.MM.YYYY').diff(
		moment(campaign.time[0], 'DD.MM.YYYY'),
		'days',
	);
	days++;

	let daysTillNow = moment().diff(
		moment(campaign.time[0], 'DD.MM.YYYY'),
		'days',
	);
	daysTillNow++;

	const budget = campaign.budget === 'advice' ? 21 : parseInt(campaign.budget);
	const tax = moment().isBefore('2021-01-01') ? 0.16 : 0.19;
	const taxEuro = budget * tax;
	const totalBudget = days * (budget + taxEuro);
	const budgetTillNow = daysTillNow > days ? days * (budget + taxEuro) : daysTillNow * (budget * taxEuro);

	state.campaign = campaign;
	state.campaign.duration = days;
	state.campaign.totalBudget = totalBudget;
	state.campaign.budgetTillNow = budgetTillNow;
	state.campaign.budgetInt = budget;
}

export function SET_CAMPAIGN_STATS(state, stats) {
	if (!stats.data) return;
	const { data, ...allTime } = stats;
	state.campaignStatsData = allTime;

	state.impressionSum = sum(data, 'impressions');
	state.impressionChart = toChartData(data, 'impressions', 'date_start');

	state.clickSum = sum(data, 'clicks');
	state.clickChart = toChartData(data, 'clicks', 'date_start');

	state.reachSum = parseInt(allTime.reach);
	state.reachChart = toChartData(data, 'reach', 'date_start');
}


export function ADD_CAMPAIGN(state, campaign) {
	state.campaigns.push(campaign);
}

export function UPDATE_CAMPAIGN(state, update) {
	if (state.campaign.id === update.id) {
		Object.assign(state.campaign, update);
	}

	const index = state.campaigns.findIndex(c => c.id === update.id);
	const [campaign] = state.campaigns.splice(index, 1);
	Object.assign(campaign, update);
	state.campaigns.splice(index, 0, campaign);
}
